<template>
    <div class="col-10 box-border d-flex flex-wrap align-items-center">
        <div class="col-3">
            <caption class="c-nmidone">nome</caption>
            <h5 class="c-ndarkfour mb-0 break">{{info.responsibleName || '-'}}</h5>
        </div>
        <div class="col-2 px-0">
            <caption class="c-nmidone">telefone</caption>
            <h5 v-if="info.responsibleMobile" class="c-ndarkfour mb-0 break">{{info.responsibleMobile | formatPhone}}</h5>
            <h5 v-else class="c-ndarkfour mb-0 break">-</h5>
        </div>
        <div class="col-3">
            <caption class="c-nmidone">e-mail</caption>
            <a class="px-0 c-ndarkfour py-0" :href="info.responsibleEmail ? `mailto:${info.responsibleEmail}` : ''">
                <h5 class=" mb-0 break">{{info.responsibleEmail || '-'}}</h5>
            </a>
        </div>        
    </div>
</template>

<script>
export default {
    props:{
        info:{
            required:true,
        }
    },
    components:{
    }
}
</script>

<style lang="scss" scoped>
</style>